// extracted by mini-css-extract-plugin
export default {"draggableNode":"draggableNode_draggableNode__DVKwB","label":"draggableNode_label__yWEqP","icon":"draggableNode_icon__xLN1E"};